import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { globalStyles } from '../global-styles.js';
import { CheckoutI18nLitElement } from '../locale/i18n-element.js';
import { t } from '../locale/localization.js';

@customElement('pp-cashier-extra')
export class PpCashierExtra extends CheckoutI18nLitElement {
  static styles = [
    globalStyles,
    css`
      :host {
        display: block;
      }

      .pp-cancel {
        text-align: var(--pp-checkout-return-position);
      }

      .pp-cancel a {
        color: var(--pp-checkout-theme-color);
      }

      @media only screen and (min-width: 0) and (max-width: 576px){
        .pp-cancel {
          padding: 0 12px;
        }
      }
    `
  ];

  @property({ type: String }) cancelUrl = '';

  @property({ type: String }) returnBtnText = '';

  get cancelText() {
    const defaultText = 'Cancel and return to seller website';
    const text = this.returnBtnText || defaultText;
    
    return text === defaultText ? t('actions.cancelAndReturnSellerWebsite') : text;
  }
  
  render() {
    return html`
      <div class="pp-cancel text-xs p-t-1 align-center">
        <a class="font-medium" href="${this.cancelUrl}">
          ${this.cancelText}
        </a>
      </div>
    `;
  }
}
